/** Export CSV (Excel FR : point-virgule + BOM). */

function csvEuro(cents: number): string {
  return (cents / 100).toFixed(2).replace(".", ",");
}

function cell(v: string | number): string {
  const s = String(v ?? "");
  if (/[;"\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCsv(filename: string, rows: (string | number)[][]): void {
  const body = rows.map((r) => r.map(cell).join(";")).join("\n");
  const blob = new Blob(["\uFEFF" + body], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export { csvEuro };
